module.exports = __webpack_public_path__ + "img/critical-icon.740d0675.svg";